export default __webpack_public_path__ + "static/media/toolbar-inactive.87943d5c.svg";